<script setup>
import axios  from "axios";
import Alert  from '@/components/common/Alert.vue';
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-dialog
        v-model="reltemp"
        width="700px"
    >
        <v-card
            width="700px"
        >
            <v-toolbar
                height="50px"
                flat
                color="#E13532"
                dark
            >
                <v-toolbar-title>
                    名前をつけてテンプレートとして保存
                </v-toolbar-title>
                <v-spacer />
                <v-icon
                    @click="reltemp=false"
                    dark
                >
                    mdi-close
                </v-icon>
            </v-toolbar>

     <Alert
        :message="message"
        :messagetitle="messagetitle"
        :messagetype="messagetype"
        v-if="message_flg==true"
     >
     </Alert>
            <v-card-text id="favblock" v-else>
                <v-row class="mt-5">
                    <v-col cols="1">
                        <span class="formlabel">名前</span>
                    </v-col>
                    <v-col>
                    <v-text-field
                      v-model="name"
                      hide-details="auto"
                      dense
                    ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-3 pb-5" v-if="message_flg==false">
                <v-spacer />
                <v-btn
                    @click="save"
                    color="#E13532"
                    :dark="!disabled"
                    :disabled="disabled"
                >
                    <v-icon>
                        mdi-content-save-edit
                    </v-icon>
                    名前をつけて保存
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props : ["template_id",],
    data : function(){
        return {
            name : "",
            reltemp : false,
            message_flg : false,
            messagetitle: "",
            message     : "",
            messagetype : 0,
			disabled    : true,
        };
    },
	watch : {
		name : function(){
			if(this.name=="")
			{
				this.disabled = true;
			}
			else
			{
				this.disabled = false;
			}
		},
	},
    computed : {
        title : function() {
            return this.$store.getters['doc_info/get_title'];
        },
        sub_title : function() {
            return this.$store.getters['doc_info/get_subtitle'];
        },
        summary : function() {
            return this.$store.getters['doc_info/get_summary'];
        },
        e_doc : function() {
            return this.$store.getters['doc_info/get_doc'];
        },
    },
    methods : {
        open : function(){
            if(this.title == "" || this.title == null)
            {
                this.messagetitle = "タイトルが入力されていません。";
                this.message      = "保存やダウンロードにはタイトルが必須項目です";
                this.messagetype  = 2;
                this.message_flg=true;
            }
            this.reltemp = true;
        },
        save : async function(){
            var params = new URLSearchParams();
            params.append("name",this.name);
            params.append("title",this.title);
            params.append("sub_title",this.sub_title);
            params.append("summary",this.summary);
            params.append("doc",this.e_doc);
            params.append("id",this.template_id);
            await axios.post("/api/release/save_template",params)
            .then(() => {
                this.messagetitle = "保存しました";
                this.message      = "保存したドキュメントは一覧から確認できます";
                this.messagetype  = 0;
                this.message_flg=true;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
    },
}
</script>
